<template>
  <div>
    <div
      v-if="loading"
      class="text-center p-5"
    >
      Loading form...
    </div>
    <div
      v-else-if="loadError"
      class="text-center p-5 text-danger"
    >
      {{ loadError }}
    </div>
    <template v-else>
      <div class="formWrapper filled">
        <div class="form-header floatCss">
          <b-row>
            <b-col cols="12">
              <div class="form-header-inner d-flex justify-content-between">
                <div class="d-flex">
                  <div class="dForm-top-logo">
                    <img :src="logoSrc">
                  </div>
                  <div class="dForm-companyDetails">
                    <div class="dForm-cmBlock">
                      <h2>
                        <span class="cm-chinese">富貴山莊</span><br><span class="cm-english">Mount Prajna Ltd.</span>
                      </h2>
                    </div>
                    <div class="dForm-cmBlock2">
                      <p>(Co. Reg. No. 200401183W)</p>
                      <p>(GST Group Reg. No. M90364395L)</p>
                    </div>
                  </div>
                </div>
                <div class="dForm-top-right d-flex">
                  <h5 class="text-block">
                    REV:3
                  </h5>
                  <h5>File No: {{ formData.fileNo || '-' }}</h5>
                  <h5>Sales Order No: {{ formData.orderNo || '-' }}</h5>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pp-section-tittle">
                <h2>installment payment plan 分期付款计划</h2>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-row class="payment-plan-section">
          <b-col cols="12">
            <b-row class="pp-wrapper-row font-pdf-custom">
              <b-col
                cols="6"
                md="6"
                lg="6"
              >
                <div class="pp-nt-block floatCss">
                  <div class="pp-nt-text pp-nt-wd-1 floatCss">
                    I,
                  </div>
                  <div class="pp-nt-text-input pp-nt-wd-2">
                    {{ formData.customerName || '-' }}
                  </div>
                </div>
              </b-col>
              <b-col
                cols="6"
                md="6"
                lg="6"
              >
                <div class="pp-nt-block-container floatCss">
                  <div class="pp-nt-block floatCss">
                    <div class="pp-nt-text pp-nt-wd-2 floatCss">
                      NRIC No.
                    </div>
                    <div class="pp-nt-text-input pp-nt-wd-3">
                      {{ formData.customerNric || '-' }}
                    </div>
                  </div>
                  <div class="pp-nt-text3">
                    the purchaser of
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="pp-wrapper-row font-pdf-custom">
              <b-col
                cols="6"
                md="6"
                lg="6"
              >
                <div class="pp-nt-block floatCss">
                  <div class="pp-nt-text pp-nt-wd-a1 floatCss">
                    Sales Order No.
                  </div>
                  <div class="pp-nt-text-input pp-nt-wd-a2">
                    {{ formData.orderNo || '-' }}
                  </div>
                </div>
              </b-col>
              <b-col
                cols="6"
                md="6"
                lg="6"
              >
                <div class="pp-nt-block floatCss">
                  <div class="pp-nt-text pp-nt-wd-2 floatCss">
                    Niche No.
                  </div>
                  <div class="pp-nt-text-input pp-nt-wd-2">
                    {{ formData.nicheNo || '-' }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="pp-wrapper-row font-pdf-custom">
              <b-col cols="12">
                <div class="pp-single-row floatCss">
                  <div class="pp-single-sd1">
                    do hereby request for the balance of the purchase prices to be settled by an installment plan.
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="pp-check-wrapper">
              <b-col cols="12">
                <div class="pp-section-tittle2">
                  <h2>mode of payment</h2>
                </div>
              </b-col>
              <b-col cols="12">
                <div class="pp-check-group">
                  <div
                    class="pp-check-single"
                    :class="{ active: formData.installmentMode === 'Via Counter or Mobile App' }"
                  >
                    Via Counter or Mobile App
                  </div>
                  <div
                    class="pp-check-single"
                    :class="{ active: formData.installmentMode === 'Direct Debit via Credit Card' }"
                  >
                    Direct Debit via Credit Card
                  </div>
                  <div
                    class="pp-check-single"
                    :class="{ active: formData.installmentMode === 'Direct Debit IPP' }"
                  >
                    Credit Card IPP
                  </div>
                  <div
                    class="pp-check-single"
                    :class="{ active: formData.installmentMode === 'Giro/eGiro' }"
                  >
                    Giro or eGiro
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="instalment-details-section">
              <b-col cols="12">
                <div class="pp-section-tittle2">
                  <h2>Installment Plan Details</h2>
                </div>
              </b-col>
              <b-col cols="12">
                <div class="pp-instalment-wrapper floatCss">
                  <div class="pp-instalment-single floatCss">
                    <div class="instalment-left-tittle floatCss">
                      Installment Plan Amount (SGD)
                    </div>
                    <div class="instalment-right-input floatCss">
                      ${{ numberFormat(formData.installmentAmount) }}
                    </div>
                  </div>
                  <div class="pp-instalment-single floatCss">
                    <div class="instalment-left-tittle floatCss">
                      Installment Tenure
                    </div>
                    <div class="instalment-right-input floatCss">
                      {{ formData.installmentTenure }}
                    </div>
                  </div>
                  <div class="pp-instalment-single floatCss">
                    <div class="instalment-left-tittle floatCss">
                      Monthly Installment Amount
                    </div>
                    <div class="instalment-right-input floatCss">
                      ${{ numberFormat(formData.monthlyInstallment) }}
                    </div>
                  </div>
                  <div class="pp-instalment-single floatCss">
                    <div class="instalment-left-tittle floatCss">
                      Final Installment Amount
                    </div>
                    <div class="instalment-right-input floatCss">
                      ${{ numberFormat(formData.finalInstallment) }}
                    </div>
                  </div>
                  <div class="pp-instalment-single floatCss">
                    <div class="instalment-left-tittle floatCss">
                      Installment Due Date
                    </div>
                    <div class="instalment-right-content floatCss">
                      <div class="pp-instalment-single2 w-100 floatCss">
                        <div class="pp-instalment-tittle-2 floatCss">
                          Commencing on 1st day of
                        </div>
                        <div class="instalment-right-input2 floatCss">
                          {{ formData.commencingDate }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pp-instalment-single floatCss">
                    <div class="instalment-left-tittle floatCss" />
                    <div class="instalment-right-content floatCss">
                      <p>and thereafter on the 1st day of each month</p>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="pp-intalment-text">
              <b-col cols="12">
                <div class="pp-bottom-info-text">
                  <p>I hereby agree that the terms and conditions contains in the Sales Order remains unchanged and the Company reserved the sole right in amending or rejecting the Installment Plan without assigning any reason thereto.</p>
                </div>
              </b-col>
            </b-row>
            <b-row class="pp-service-text">
              <b-col cols="12">
                <div class="pp-section-tittle2">
                  <h2>PARTICULARS of Sales and Service Agent  销售代理及服务代理资料</h2>
                </div>
              </b-col>
              <b-col cols="12">
                <div class="service-pp-info floatCss">
                  <div class="service-pp-left-info">
                    Agency 区代理
                  </div>
                  <div class="service-pp-right-info">
                    {{ formData.salesAgentAgency }}
                  </div>
                </div>
              </b-col>
              <b-col cols="12">
                <div class="service-pp-info floatCss">
                  <div class="service-pp-left-info">
                    Sales Agent 销售代理
                  </div>
                  <div class="service-pp-right-info">
                    {{ formData.salesAgentName }}
                  </div>
                </div>
              </b-col>
              <b-col cols="12">
                <div class="service-pp-info floatCss">
                  <div class="service-pp-left-info">
                    Agency 区代理
                  </div>
                  <div class="service-pp-right-info">
                    {{ formData.serviceAgentAgency }}
                  </div>
                </div>
              </b-col>
              <b-col cols="12">
                <div class="service-pp-info floatCss">
                  <div class="service-pp-left-info">
                    Service Agent 服务代理
                  </div>
                  <div class="service-pp-right-info">
                    {{ formData.serviceAgentName }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="footer-signature-area">
              <b-col cols="12">
                <div class="pp-signature-area floatCss">
                  <p>Purchaser 购买者签名</p>
                </div>
              </b-col>
              <b-col cols="12">
                <b-row>
                  <b-col
                    cols="6"
                    md="6"
                    lg="6"
                  >
                    <div
                      v-if="formData.sign"
                      class="pp-signature-block floatCss"
                    >
                      <img
                        :src="formData.sign"
                        alt="signature"
                      >
                    </div>
                    <div
                      v-else
                      id="sign"
                      class="pp-signature-block signature-block-yellow floatCss"
                    >
                      <span>Sign here</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12">
                <div
                  class="pp-signature-area floatCss"
                >
                  <h4>Name 姓名: {{ formData.customerName }}</h4>
                  <h4>Date 日期: {{ (formData.signDate ? dateFormatWithTime(formData.signDate) : '') }}</h4>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/nr-logo.png'),
      formData: {},
      loading: true,
      loadError: null,
    }
  },

  created() {
    this.loadFormData()
  },

  methods: {
    // App opens this page in a webview with the saved form's id (route param) - fetches the
    // data the app earlier saved via POST /sales/form/installment/pedestal/data instead of reading injected
    // localStorage, which is what the Puppeteer-rendered source form still does.
    //
    // This hits the front-end/ router (optionalAuth, no token required - the id itself is the
    // access control), not reservation-app/ - so this.$http is safe to use here: no 401 is
    // possible, meaning its global interceptor's hard-redirect-to-/login (src/libs/axios.js)
    // never triggers.
    loadFormData() {
      const { id } = this.$route.params
      this.$http.get(`front-end/sales/form/installment/pedestal/data/${id}`)
        .then(response => {
          this.formData = response.data.data
          this.loading = false
        })
        .catch(error => {
          this.loadError = (error.response && error.response.data && error.response.data.message) || 'Unable to load form data.'
          this.loading = false
        })
    },
  },
}
</script>
